import * as R from "ramda";

import { getFeesWithCosts } from "reducers/fees";
import { getFeeTotals } from "reducers/projects";
import { Fee } from "types/entities";
import { filterByPropValues } from "utils/func";

import resourceOperations, { ReadOptions } from "./resourceOperations";

const operation = resourceOperations({
  basePath: "/api/fees",
  baseKey: ["fees"],
});

export const useFee = (id: number, opts: ReadOptions = {}) => operation.useRead<Fee>(id, opts);

export const useFees = (opts: ReadOptions = {}) => operation.useRead<Fee[]>(null, opts);

export const useFeesForRequirementID = (id: number, opts: ReadOptions = {}) =>
  useFees({
    ...opts,
    select: R.filter((r: any) => r.requirement_id === id),
  });

export const useFeesByID = (ids: number[] = [], opts: ReadOptions = {}) =>
  useFees({
    ...opts,
    select: R.filter((r: any) => ids.includes(r.id)),
  });

export const useFeesWithCosts = (requirementIDs, project) =>
  useFees({
    select: (fees) => {
      const requirementFees = filterByPropValues("requirement_id", requirementIDs, fees);
      return getFeesWithCosts(getFeeTotals(project), requirementFees);
    },
  });
